var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88821 0.191657C5.0093 0.0676436 5.16341 -1.45752e-07 5.34503 -1.45752e-07C5.70829 -1.45752e-07 6 0.293123 6 0.665163C6 0.851184 5.92295 1.02029 5.79636 1.14994L1.94362 5.00564L5.79636 8.85006C5.92295 8.97971 6 9.15445 6 9.33484C6 9.70688 5.70829 10 5.34503 10C5.16341 10 5.0093 9.93236 4.88821 9.80834L0.606164 5.52424C0.452055 5.37768 0.380504 5.19729 0.375 5C0.375 4.80271 0.452055 4.6336 0.606164 4.4814L4.88821 0.191657Z",
    fill: "#1D1E2C",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonAngleLeft);
export default __webpack_public_path__ + "static/media/button-angle-left.9214c51df3eae5970458176c1250a039.svg";
export { ForwardRef as ReactComponent };